import api from './api';
import { DriverRidePreferences } from '../types';

const DEFAULT_PREFERENCES: DriverRidePreferences = {
  pickupKeywords: [],
  dropoffKeywords: [],
  routeKeywords: [],
  vehicleTypes: [],
  serviceAreas: [],
  currentLocation: {
    address: '',
    coordinates: { lat: 0, lng: 0 },
  },
  defaultRadius: 5,
  workingHoursEnabled: false,
  workingHours: {
    start: '06:00',
    end: '22:00',
  },
};

const toList = (value: unknown): string[] =>
  Array.isArray(value) ? value.map(String).filter(Boolean) : [];

export const normalizeRidePreferences = (raw: any): DriverRidePreferences => {
  const legacyKeywords = toList(raw?.locationPreferences);
  return {
    pickupKeywords: toList(raw?.pickupKeywords),
    dropoffKeywords: toList(raw?.dropoffKeywords),
    routeKeywords: toList(raw?.routeKeywords).length ? toList(raw?.routeKeywords) : legacyKeywords,
    vehicleTypes: toList(raw?.vehicleTypes),
    serviceAreas: Array.isArray(raw?.serviceAreas) ? raw.serviceAreas : [],
    currentLocation: raw?.currentLocation || DEFAULT_PREFERENCES.currentLocation,
    defaultRadius: Number(raw?.defaultRadius || DEFAULT_PREFERENCES.defaultRadius),
    workingHoursEnabled: Boolean(raw?.workingHoursEnabled),
    workingHours: {
      start: raw?.workingHours?.start || DEFAULT_PREFERENCES.workingHours.start,
      end: raw?.workingHours?.end || DEFAULT_PREFERENCES.workingHours.end,
    },
  };
};

export const fetchRidePreferences = async (): Promise<DriverRidePreferences> => {
  try {
    const response = await api.get('/api/driver/preferences');
    return normalizeRidePreferences(response.data);
  } catch {
    try {
      const response = await api.get('/api/settings/ridePreferences');
      return normalizeRidePreferences(response.data);
    } catch {
      const response = await api.get('/api/settings');
      return normalizeRidePreferences(response.data?.ridePreferences);
    }
  }
};

export const saveRidePreferences = async (
  preferences: DriverRidePreferences
): Promise<DriverRidePreferences> => {
  const payload = {
    autoAcceptRides: false,
    autoAcceptMatching: false,
    pickupKeywords: preferences.pickupKeywords,
    dropoffKeywords: preferences.dropoffKeywords,
    routeKeywords: preferences.routeKeywords,
    locationPreferences: preferences.routeKeywords,
    vehicleTypes: preferences.vehicleTypes,
    serviceAreas: preferences.serviceAreas,
    currentLocation: preferences.currentLocation,
    defaultRadius: preferences.defaultRadius,
    workingHoursEnabled: preferences.workingHoursEnabled,
    workingHours: preferences.workingHours,
  };

  const response = await api.put('/api/driver/preferences', payload);
  return normalizeRidePreferences(response.data.ridePreferences || response.data);
};

export const defaultRidePreferences = DEFAULT_PREFERENCES;
